'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _jobDetails = require('./job-details.component');

var _jobDetails2 = _interopRequireDefault(_jobDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jobDetailsModule = _angular2.default.module('app.containers.job-details', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('jobDetails', {
    url: '/jobs/:jobId',
    template: '<job-details></job-details>'
  });
}).component('jobDetails', _jobDetails2.default);

exports.default = jobDetailsModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/job-details/job-details.js
 **/